/* src/app/indirect-rate/indirect-rate-rule/indirect-rate-rule-presenter/indirect-rate-rule.component.scss */
body#themeTag :host ::ng-deep .p-grid {
  margin: 0;
}
/*# sourceMappingURL=indirect-rate-rule.component.css.map */
